import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Button from '@components/button/Button'
import Tag from '@components/tag/Tag'
import Animators from '@components/root/Animators'

import useI18n from '@i18n/useI18n'

import { AdminPlanFormScheme, AdminPlanFormFields } from '../scheme'

const FormLayout = ({ step, form, onNext, onBack, onQuit, children }: AdminPlanLayoutProps) => {
  const i18n = useI18n()

  const [valid, setValid] = React.useState(false)

  const fields = React.useMemo(() => AdminPlanFormFields[step].map((key) => form[key]), [form, step])

  React.useEffect(() => {
    const schema = AdminPlanFormScheme[step as keyof typeof AdminPlanFormScheme]

    if (schema) {
      schema
        .validate(form)
        .then(() => setValid(true))
        .catch((err) => setValid(false))
    }
  }, [fields, step])

  return (
    <MainContainer>
      <DualLine>
        <Column left>
          <TagContainer>
            <Tag
              activeColor
              focused
              item={{ label: i18n.t('common.quit'), value: 'tag' }}
              selected={false}
              leftIcon="close"
              onItemSelected={onQuit}
            />
          </TagContainer>

          <Animators>
            <SubTitle>{i18n.t('screens.admin.plans.form.title')}</SubTitle>
            <Title>{i18n.t(`screens.admin.plans.form.${step}.title`, form)}</Title>
          </Animators>
        </Column>

        <Column>{children}</Column>
      </DualLine>

      <Buttons>
        <ButtonContainer>
          <Button
            label={i18n.t('screens.incident.previous')}
            status="active"
            onClick={onBack}
            textOnly
            color="light"
            textColor={theme.colors.primaryText}
          />
        </ButtonContainer>
        <ButtonContainer>
          <Button label={i18n.t('common.validate')} status={valid ? 'active' : 'disabled'} onClick={onNext} />
        </ButtonContainer>
      </Buttons>
    </MainContainer>
  )
}

export default FormLayout

const MainContainer = styled(View)`
  flex: 1;
  flex-direction: column;
`

const DualLine = styled(View)`
  flex: 1;
  flex-direction: row;
`

const Column = styled(View)<{ left?: boolean }>`
  flex: 1;
  flex-direction: column;
  background-color: ${(props) => (props.left ? props.theme.colors.cardSecondary : props.theme.colors.background)};
  position: relative;
`

const SubTitle = styled(Text)`
  ${(props) => props.theme.fonts.Title2};
  color: ${(props) => props.theme.colors.secondaryText};
  font-size: 20px;
  margin: 0 24px;
  margin-bottom: 15px;
  margin-top: 125px;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Heading1};
  margin: 0 24px;
`

const Buttons = styled(View)`
  flex-direction: row;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.background};
`

const ButtonContainer = styled(View)`
  width: 275px;
  margin: 12px;
`

const TagContainer = styled(View)`
  position: absolute;
  top: 24px;
  left: 24px;
`
